module.exports = __webpack_public_path__ + "static/media/token_evolution.2ad8e6c0.png";